import type { InterventionTemplateSelectOptionProps } from "./intervention-template-select-option.type";

import { Select } from "antd";

import { InterventionTemplateSelectLabel } from "../intervention-template-select-label";

// TODO DEV-8551 `Option` is deprecated. Please use `options` instead.
// eslint-disable-next-line @typescript-eslint/no-deprecated
const { Option } = Select;

export const InterventionTemplateSelectOption = ({
  option,
}: InterventionTemplateSelectOptionProps) => (
  <Option key={option.id} value={option.id}>
    <InterventionTemplateSelectLabel template={option} />
  </Option>
);
